import React from 'react';
import { Search } from '../';
import { useStaticQuery, graphql } from "gatsby";
import { OtherTranslations } from '../../hooks/queries/OtherTranslations';
import { Link } from 'gatsby-plugin-intl';
import { getCurrentLangKey } from '../../utils/getCurrentLangKey';
import { getCurrentCountryCode } from '../../utils/getCurrentCountryCode';
import { getLinkPrefix } from '../../utils/getLinkPrefix';

export const WelcomeSellBox = ({ location }) => {
  const langKey = getCurrentLangKey();
  const country_code = getCurrentCountryCode();
  const translation_data = OtherTranslations();
  const t = translation_data.mb.otherTranslation.localizations.find(item => item.locale === langKey) || translation_data.mb.otherTranslation;
  const data = useStaticQuery(pageQuery);
  let query = "";
  if (location && location.search) {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('query')) {
      query = searchParams.get('query');
    }
  }

  return (
    <div className="block welcome-sell-box">
      <div className="container-fluid">
        <h1 className="text-center">{t.search_sellbox_title}</h1>
        <div className="row row-centered">
          <div className="col-md-6 col-sm-8 col-xs-12 col-centered">
            <Search query={query} placeholder={t.search_sellbox_placeholder} langKey={langKey} />
          </div>
        </div>
        <p className="text-center">
          <strong>{t.search_sellbox_topics_description} </strong>

          {data.mb.common_topics && data.mb.common_topics.length ?
            data.mb.common_topics.map((item, index) => {
              const localized_item = item.localizations.find(item => item.locale === langKey) || item;
              return (
                <span key={item.id}>
                  {item.show_search_results ?
                    // Need to force page reload when passing params to search
                    <a href={`/support-center/${langKey}/${country_code}/search?query=${encodeURIComponent(item.topic)}`} className="topic_link">
                      {localized_item.topic}
                    </a>
                    :
                    <Link to={getLinkPrefix('articles', `${item.slug_of_article}`)} language={langKey} className="topic_link">
                      {localized_item.topic}
                    </Link>}
                  {index + 1 < data.mb.common_topics.length ? ', ' : ''}
                </span>
              )
            })
            : null
          }
        </p>
      </div>
    </div>
  )
}
const pageQuery = graphql`
  query CommonTopicsQuery {
    mb {
      common_topics: commonTopics(sort: "sort_index:asc") {
        id
        topic
        show_search_results
        slug_of_article
        sort_index
        locale
        localizations {
          id
          topic
          show_search_results
          slug_of_article
          sort_index
          locale
        }
      }
    }
  }
`
